import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import logo_merchant from "../../common/media/cc_logo_color.svg"; // use here or from cloudinary
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../common/components/Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';

import { projects as getProjects } from '../../common/api/projects'
import Popover from "../../common/components/popover/popover.js";
import { getFlightSuffix } from "../../common/util/unitConverter";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ projects, merchantCode, fetchedImpact }) => {

    const passengerDistance = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.flightsImpact?.passengerDistance?.value))
    const passengerDistanceUnit = fetchedImpact && !fetchedImpact.error && getFlightSuffix(fetchedImpact.flightsImpact?.passengerDistance?.unit.toLowerCase());
    const numberOfPassengers = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.flightsImpact?.numberOfPassengers.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);

    const treeMetric = treeGrowthYears && <span className="translate-dynamic"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as</span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
    


    return (
        <div>
            <div className="p-3 text-center">
                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1625183260/Enterprise/galapagos/logo_k5jgth.svg`} style={{ height: '90px' }} />
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                <div className="container color-white text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="mw-720px">
                            <h1 className="mb-4 text-shadow mt-0 color-white">Travelling climate friendly has never been easier</h1>
                            <h3 className="mb-3 text-shadow color-white">Galapagos Ecological Airport Climate Friendly Traveller helps you reduce the environmental impact of travel</h3>
                            <div className="mobile-hide mb-4">
                                <a className="btn btn-primary btn-lg color-white" href="#FlightCalculator">Offset My Flight</a>
                            </div>
                        </div>
                        <div className="d-flex">
                            <h4 className="mr-2 mt-0 color-white">Powered By</h4>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} alt="Carbonclick logo" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <img className="mb-3" src={logo} style={{ height: 26 }} alt="Carbonclick logo" />
                        <h2 className="mb-4 text-shadow mt-0 color-white">Travelling climate friendly has never been easier</h2>
                        <a className="btn btn-primary btn-lg font-bold color-white" href="#FlightCalculatorDummy">Offset My Flight</a>
                    </div>
                </div>
            </div>

            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <h5 className="mr-2 font-bold mt-1 mb-0 color-white">Powered By</h5>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="full-py-6 mobile-pyt-2">
                <div className="text-center">
                    <div className="mb-3 px-3 center mw-600px">
                        <h3 className="font-bold">Travel Climate Friendly</h3>
                        <div className="bg-primary center mb-2" style={{height: '3px', width: '40%'}}></div>
                        <h5>The Galapagos Ecological Airport Climate Friendly Traveller helps you effortlessly reduce the environmental impact of your trip, with high quality projects that make a real traceable difference. Together we are fighting climate change.</h5>
                    </div>
                    <div className="py-6 mobile-hide">
                        <div className="center mb-3 py-4 px-3 position-relative" >
                            <div className="p-3 bg-white position-relative z-2 w-fit center">
                                <h1 className="title">{passengerDistance}</h1>
                                {passengerDistanceUnit && <h5 className="font-bold translate-dynamic" >Carbon Neutral Air {passengerDistanceUnit}</h5>}
                            </div>

                            <div className="position-absolute w-100" style={{top: '38%', left: '0' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1174" height="47" viewBox="0 0 1174 47" fill="none">
                                    <path d="M909.659 25.7969C910.383 25.0687 910.781 24.0946 910.781 23.0539C910.781 22.0269 910.393 21.0647 909.687 20.3397C909.678 20.3301 909.669 20.3205 909.659 20.3109C908.936 19.5827 907.98 19.1935 906.968 19.2149L898.949 19.3846L892.075 5.33145L886.006 5.33144L889.306 19.5886L882.091 19.7413L879.773 16.4238L873.913 16.4237L877.018 23.054L873.913 29.6842L879.773 29.6842L882.091 26.3667L889.306 26.5194L886.006 40.7766L892.075 40.7767L898.949 26.7235L906.968 26.8931C907.98 26.9144 908.936 26.5251 909.659 25.7969ZM907.006 24.9813L897.814 24.7868L890.927 38.8644L888.361 38.8644L891.649 24.6563L881.15 24.4342L878.818 27.772L876.874 27.772L879.083 23.054L876.874 18.3359L878.818 18.3359L881.15 21.6737L891.649 21.4516L888.361 7.24365L890.927 7.24369L897.814 21.3213L907.006 21.1268C907.514 21.116 907.994 21.3115 908.357 21.677C908.362 21.6817 908.367 21.6866 908.371 21.6914C908.725 22.0553 908.92 22.5384 908.92 23.054C908.92 23.5765 908.72 24.0654 908.357 24.431C907.994 24.7965 907.514 24.9919 907.006 24.9813Z" fill="#0A8137"/>
                                    <path d="M2 23.0005H408H866M918.5 23.0005H1172" stroke="#0A8137" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="8 12"/>
                                </svg>
                            </div>
                        </div>

                        <div className="mw-800px center">
                            <div className="row text-left m-0">

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover h-160px border-r6 impact-community w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{numberOfPassengers}</h2>
                                            <p>Climate Friendly Travellers</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover h-160px border-r6 impact-CO2 w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{carbonOffsetImpact}</h2>
                                            <p>{carbonOffsetImpactUnit} of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover h-160px border-r6 impact-trees w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{treeGrowthYears}</h2>
                                            <p><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-show bg-primary py-3 mt-4 text-center">
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                        <div key="1" >
                            <div className="mb-3">
                                <div className="center w-100 px-3">
                                    <div className="img-cover h-240px impact-flight w-100">

                                    </div>
                                    <div className="py-4 font-bold color-white">
                                        <h2 className='color-white'>{passengerDistance}</h2>
                                        <p>Carbon Neutral Air {passengerDistanceUnit}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div key="2" >
                            <div className="mb-3">
                                <div className="center w-100 px-3">
                                    <div className="img-cover h-240px impact-community w-100">

                                    </div>
                                    <div className="py-4 font-bold color-white">
                                        <h2 className='color-white'>{numberOfPassengers}</h2>
                                        <p>Climate Friendly Travellers</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div key="3">
                            <div className="mb-3">
                                <div className="center w-100 px-3">
                                    <div className="img-cover h-240px impact-CO2 w-100">

                                    </div>
                                    <div className="py-4 font-bold color-white">
                                        <h2 className='color-white'>{carbonOffsetImpact}</h2>
                                        <p>{carbonOffsetImpactUnit} of CO2 Offset</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div key="4">
                            <div className="mb-3">
                                <div className="center w-100 px-3">
                                    <div className="img-cover h-240px impact-trees w-100">
                                    </div>
                                    <div className="py-4 font-bold color-white">
                                        <h2 className='color-white'>{treeGrowthYears}</h2>
                                        <p><span className="mr-2">Tree Growth Years</span>
                                            <Popover content={treeMetric} >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                </svg>
                                            </Popover>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </div>

            <div className="bg-primary pattern-1 py-5 img-contain" id="FlightCalculator" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "left" }}>
                <div className="container-parent">    
                    <div className="container mobile-p-0">
                        <div className="center shadow-lg">
                            <div id="FlightCalculatorDummy"/>
                            <FlightCalculator merchantCode={merchantCode} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-6 mobile-pyt-2 mobile-p-0">
                <div className="mb-3 mobile-pyt-2 center mw-600px">
                    <h3 className="font-bold">We Are The World's First<br/>Ecologically Friendly Airport</h3>
                    <div className="bg-primary mb-2 center " style={{height: '3px', width: '40%'}}></div>
                </div>

                <div className="container text-center full-mb-5 mobile-mb-0">
                    <div className="center mw-800px">
                        <iframe src="https://player.vimeo.com/video/577396844?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" className="w-100 mobile-h-270" height="440" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                    </div>
                </div>


            <div className="text-center py-3" style={{backgroundColor: '#f3f5ff'}}>
                <div className="container">
                    <div className="row pt-3">
                        <div className="col-4 text-center mb-3">
                            <img className="h-120px" src={`https://res.cloudinary.com/carbonclick/image/upload/v1626389595/Enterprise/galapagos/image_115_mehwrq.png`} />
                            <p className="mb-0 font-bold">LEED GOLD CERTIFICATION</p>
                        </div>
                        <div className="col-4 text-center mb-3">
                            <img className="h-120px" src={`https://res.cloudinary.com/carbonclick/image/upload/v1626389594/Enterprise/galapagos/Group_826_fpb43i.png`} />
                            <p className="mb-0 font-bold">AIRPORT CARBON ACCREDITATION</p>
                        </div>
                        <div className="col-4 text-center mb-3">
                            <img className="h-120px" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629147557/Enterprise/galapagos/ASQ_logo2019_CMYK_1_grpdoi.png`} />
                            <p className="mb-0 font-bold">ASQ CUSTOMER EXPERIENCE AWARD 2019</p>
                        </div>
                    </div>
                </div>
            </div>


            </div>

            <div className="mb-3">
                <div className="container text-center" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "right" }}>
                    <Carousel showIndicators={false} dynamicHeight={false} showThumbs={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                        <div key="1">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626906869/Enterprise/galapagos/gal-img-1_gjdunu.png`} />
                        </div>
                        <div key="2">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626737627/Enterprise/galapagos/gal-5_tzxrcu.png`} />
                        </div>
                        <div key="3">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626737626/Enterprise/galapagos/gal-2_wazrye.png`} />
                        </div>
                        <div key="4">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626737626/Enterprise/galapagos/gal-3_kurak3.png`} />
                        </div>
                        <div key="5">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626737628/Enterprise/galapagos/gal-1_ykkbux.png`} />
                        </div>
                        <div key="6">
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1626737627/Enterprise/galapagos/gal-4_lg5tv5.png`} />
                        </div>
                    </Carousel>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-6 d-grid mb-3">
                        <div className="img-cover img-1">

                        </div>
                    </div>
                    <div className="col-6 d-grid mb-3 full-py-6">
                        <div className="mw-600px">
                            <div className="bg-primary mb-2" style={{height: '3px', width: '84px'}}></div>
                            <p>Galapagos Ecological Airport is the first ecologically friendly airport in the world having been awarded the LEED Gold certification by the US Green Building Council.
                                <br /><br />
                                This certification is granted for the airport's design and construction, as reflected in our new terminal, that optimizes the use of energy, lighting and water consumption as well as by the use of recycled and ecologically manufactured materials.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 d-grid mb-3 full-py-6">
                        <div className="mw-600px right">
                            <div className="bg-primary mb-2" style={{height: '3px', width: '84px'}}></div>
                            <p>Galapagos Ecological Airport has also achieved carbon neutral status as the first airport in Latin America & the Caribbean to reach Level 3+ Airport Carbon Accreditation through our ambitious fuel and energy reduction initiatives.
                                <br /><br />
                                The airport is powered by 100% renewable energy and is ISO 14001 Certified, meaning we have identified the environmental impact of the airport and work to continually improve our environmental performance.
                                <br /><br />
                                We are proud to protect the Galapagos as a Unesco World Heritage Site and to be part of a movement leading efforts to protect the planet.
                            </p>
                        </div>
                    </div>
                    <div className="col-6 d-grid mb-3">
                        <div className="img-cover img-2">

                        </div>
                    </div>
                </div>
            </div>

            {projects && <>
                <div className="full-py-6 translate-dynamic">
                    <div className="container text-center">
                        <div className="mb-5 center mw-720px">
                            <h3 className="font-bold">Support Projects That Fight<br />Climate Change</h3>
                            <div className="bg-primary mb-2 center " style={{height: '3px', width: '40%'}}></div>
                            <p>CarbonClick and Galapagos Ecological Airport supports only the highest quality carbon offsetting projects around the world.<br/><br/>We work with curated international projects as Ecuador does not yet have any of its own. Supporting these projects helps fight climate change and protect our beautiful country and the planet.</p>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>}

            <div className="py-6 mobile-p-0">
                <div className="container text-center">
                    <div className="mb-3 center mw-600px">
                        <h3 className="font-bold">Climate Friendly Traveller FAQs</h3>
                        <div className="bg-primary mb-2 center " style={{height: '3px', width: '40%'}}></div>
                    </div>
                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"How are flight emissions calculated?"}>Emissions are calculated based on the individual route flown, taking into account the distance travelled as well as the type of aircraft, seating configuration, aircraft age, and typical load factors on your particular route.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"How do I know the offset is trustworthy?"}>CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website. Neither Corporación América nor the Galapagos Ecological Airport receive money for this management. We are collaborators that allow the compensation of GHG emissions according to our vision and business mission.</Accordian>
                    </div>
                    <a href={footerLinks.faq} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg font-bold color-white" >View All</a>
                    <div className="mobile-show py-5"></div>
                </div>
            </div>


<div>
    <div className="text-center mb-3">
        <a href={"https://www.caap.aero/"} target="_blank" rel="noopener noreferrer">
            <img className="h-120px mb-3" src={`https://res.cloudinary.com/carbonclick/image/upload/v1626389594/Enterprise/galapagos/image_116_yjwst2.png`} />
        </a>        
        <p className="mb-0 font-bold">Corporación América</p>
        <div className="mb-3 px-3 center mw-600px">
            <p>Corporación América Airports, operator of Galapagos Ecological Airport, acquires, develops and operates airport concessions globally. <br/> Corporación América Airports is the largest private airport operator in the world based on the number of airports, with 52 airports in 7 countries across Latin America and Europe.</p>
        </div>
    </div>
</div>

            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}


            <div className="w-100 img-cover footer-img py-6" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 24 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;